import React from "react";
import { Link } from "react-router-dom";
import { Buffer } from "buffer";
import Loader from "../loader/Loader";

export default function AllBlogsCard({ blogs }) {
  return (
    <>
      {!blogs ? (
        <Loader />
      ) : (
        <>
          {blogs &&
            blogs.map((curElem) => {
              console.log(curElem);
              debugger;
              const {
                _id,
                blog_feature_img,
                category,
                updatedAt,
                description,
                title,
                author,
                author_profile,
              } = curElem;
              let featureImgbufferToBase64 = blog_feature_img.data.data;
              let userProfilebufferToBase64 = author_profile.data.data;
              let buffFeatureImg = new Buffer(featureImgbufferToBase64);
              let buffUserProfile = new Buffer(userProfilebufferToBase64);
              let base64dataFeatureImg = buffFeatureImg.toString("base64");
              let base64dataUserProfile = buffUserProfile.toString("base64");
              var date = new Date(updatedAt);
              let splitedDate = date.toString().split(" ");
              let month = splitedDate[1];
              let day = splitedDate[2];
              let year = splitedDate[3];
              var hours = date.getHours();
              var minutes = date.getMinutes();
              var ampm = hours >= 12 ? "pm" : "am";
              hours = hours % 12;
              hours = hours ? hours : 12; // the hour '0' should be '12'
              hours = hours < 10 ? "0" + hours : hours;
              minutes = minutes < 10 ? "0" + minutes : minutes;
              var dateTime =
                month +
                ", " +
                day +
                " " +
                year +
                " at " +
                hours +
                ":" +
                minutes +
                " " +
                ampm;
              return (
                <div className="col-lg-4 mb-4" key={_id}>
                  <div className="card text-start">
                    <div className="card-img">
                      <Link to={"/single/" + _id}>
                        <img
                          src={`data:image/png;base64,${base64dataFeatureImg}`}
                          className="w-100"
                          alt=""
                        />
                      </Link>
                    </div>
                    <div className="card-body">
                      <Link
                        to={"/category/" + category}
                        className="m-0 Category"
                      >
                        {category}
                      </Link>
                      <Link to={"/single/" + _id}>
                        <h3 className="m-0">{title}</h3>
                      </Link>
                      <small className="m-0">{dateTime}</small>
                      <p className="m-0 desc">
                        {description.length > 150
                          ? description.slice(0, 150) + "..."
                          : description}
                      </p>
                      <div className="user d-flex align-items-center">
                        <div className="user-img">
                          <img
                            src={`data:image/png;base64,${base64dataUserProfile}`}
                            alt=""
                          />
                        </div>
                        <div className="user-name">
                          <Link to={"/author/" + author} className="m-0">
                            {author}
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
        </>
      )}
    </>
  );
}
